import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Rx';

import { GUID } from "app/brightserve/brightserve.module";
import { Client, Person, Incident } from "app/shared/shared.module";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
@Injectable()

export class ClientsService {

    constructor(private http: HttpClient) { }

    CreateClient(Client: Client) {
        return this.http.post("/client/create", { Client: Client })
            .map((res: any) => res || {});
    };

    UpdateClient(Id: GUID, Client: Client) {
        return this.http.put("/client/" + Id, { Client: Client })
            .map((res: any) => res || {});
    };
    AddSyncClient(Id: GUID, Client: Client) {
        return this.http.put("/client/add-sync/", { Id: Client.Id, NewSyncId: Client.NewSyncId })
            .map((res: any) => res || {});
    };

    GetClients(): Observable<Client[]> {
        return this.http.get("/client/list")
            .map((res: any) => res.Clients.map(xx => new Client(xx) || {}));
    };

    GetClient(Id: GUID): Observable<Client> {
        return this.http.get("/client/" + Id)
            .map((res: any) => new Client(res.Client) || {});
    };
}



// WEBPACK FOOTER //
// ./src/app/clients/clients.service.ts